import {Settings} from "../settings";
import {LocalizationConstants} from "./Constants/LocalizationConstants";
import {Route} from "./Utils/Helpers";

declare var require;

export interface IUpdateLocale {
    updateLocale();
}

export class LocalizationContents extends LocalizationConstants {
    public static ___current = LocalizationContents.getUserLanguage();
    public static ___content: {
        [key: string]: {
            "en": string,
            "fr": string,
        }
    } = require("../locale.json");

    public static setLanguage(lang: string) {
        const urlLocale = Route.searchParam('locale');

        if (typeof urlLocale !== 'undefined') {
            if (urlLocale === 'en' || urlLocale === 'fr') {
                lang = urlLocale;
            }
        }

        LocalizationContents.___current = lang;
    }

    public static getLanguage() {
        return LocalizationContents.___current;
    }

    public static getUserLanguage(): string {
        console.log('Settings.language', Settings.language);

        return Settings.language; //navigator.language.slice(0, 2);
    }
}


LocalizationConstants.getText = (key) => {
    return LocalizationContents.___content[key]?.[LocalizationContents.___current].replace(/\\n/g, "\n") || "ERROR!";
};
